import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuditLogService } from './audit-log.service';
import { AuditLogListItem } from '@models/resources/audit-log.model';
import { environment } from '../../../../environments/environment';

/**
 * HTTP-Variante des Audit-Log-Service (Sprint 6 S6-10).
 *
 * Bindings an `GET /api/audit-logs?auditable_type=<Model>&auditable_id=<id>`
 * (Tech-Konzept §4.2.6, read-only, Staff-only). `auditable_type` ist der
 * unqualifizierte Model-Name wie er von der BE-`AuditableTrait` gepflegt
 * wird — z.B. `'TransactionRequest'`, `'Customer'`, `'Document'`.
 *
 * Limit auf serverseitig 50 Einträge (Tech-Konzept §4 — letzte 50 Events
 * pro Entity, ältere via Paginate-Endpoint in Phase 2).
 */
@Injectable()
export class HttpAuditLogService implements AuditLogService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/audit-logs`;

  getForEntity(
    auditableType: string,
    auditableId: number,
  ): Observable<AuditLogListItem[]> {
    const params = new HttpParams()
      .set('auditable_type', auditableType)
      .set('auditable_id', String(auditableId));
    return this.http.get<AuditLogListItem[]>(this.base, { params });
  }
}
